export default "__VITE_ASSET__BGjuFKx7__"